@use "../../../../../src/styles/Colors.scss" as Colors;
@use "../../../../../src/styles/Constants.scss" as Constants;

.icon {
	width: Constants.$val-spacing-l;
	align-self: center;
	justify-content: center;
	font-size: Constants.$val-icon16,
}

.pwRequirementsElement {
	p {
		margin: 0px;
	}

	padding-bottom: 10px;
}

.pwRequirementsContainer {
	display: flex;
 	align-items: center;

	p {
		margin: 0px;
	}
}

.textGrey {
	color: Colors.$col-design-grey13 !important;
}

.imageRow {
	display: flex;
	padding: Constants.$val-spacing-m Constants.$val-spacing-l;
	align-items: center;

	& > * + * {
		margin-left: Constants.$val-spacing-s;
	}
}